export default "__VITE_ASSET__BJW0fK6H__"